// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 1650px) {

  html{
    font-size: 90%;
  }

  .category-filters .reset-button {
    cursor: pointer;
    display: flex;
    height: 30px;
  }
  .budget-content-container .category-filters select {
    width: 200px;
  }
  .budget-content-container .crud-section h2 {
    font-size: 1.4rem;
  }
  .login-container .login-content-container h1 {
    font-size: 2.5rem;
  }
  .login-content-container .box-container {
    padding: 2rem 2rem 3rem 2rem;
  }
  .box-container h4 {
    font-size: 1.4rem;
  }
  .box-container form label {
    font-size: 0.9rem;
  }
  .box-container form input {
    font-size: 0.8rem;
  }
  .box-container form .form-check {
    display: flex;
    align-items: center;
    gap: 5px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/responsive.css"],"names":[],"mappings":"AAAA;;EAEE;IACE,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,aAAa;IACb,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;EACV;AACF","sourcesContent":["@media (max-width: 1650px) {\r\n\r\n  html{\r\n    font-size: 90%;\r\n  }\r\n\r\n  .category-filters .reset-button {\r\n    cursor: pointer;\r\n    display: flex;\r\n    height: 30px;\r\n  }\r\n  .budget-content-container .category-filters select {\r\n    width: 200px;\r\n  }\r\n  .budget-content-container .crud-section h2 {\r\n    font-size: 1.4rem;\r\n  }\r\n  .login-container .login-content-container h1 {\r\n    font-size: 2.5rem;\r\n  }\r\n  .login-content-container .box-container {\r\n    padding: 2rem 2rem 3rem 2rem;\r\n  }\r\n  .box-container h4 {\r\n    font-size: 1.4rem;\r\n  }\r\n  .box-container form label {\r\n    font-size: 0.9rem;\r\n  }\r\n  .box-container form input {\r\n    font-size: 0.8rem;\r\n  }\r\n  .box-container form .form-check {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 5px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
